import React, { useState, useEffect, useCallback } from 'react';
import {
  Divider,
  Dialog as MuiDialog,
  Drawer,
  Box,
  Stack,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import { callAPI } from '../../utils';
import FormField from './formField';
import '../../../css/spinner.css';
import Button from '../../ui/button';
import Dialog from '../../ui/dialog';
import { Delete20Regular, Dismiss20Regular } from '@fluentui/react-icons';

const FormModal = ({
  fieldsConfig,
  data,
  changes,
  mode,
  title,
  type,
  submitAPI,
  deleteAPI,
  onSubmitSuccess,
  onClose,
  formData,
  setFormData,
  initialFormData,
}) => {
  const [loading, setLoading] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const handleChange = ({ target: { id, value } }) => {
    setFormData((prev) => {
      const [section, field] = id.split('.');
      return { ...prev, [section]: { ...prev[section], [field]: value } };
    });
  };

  const handleMultiSelectChange = ({ target: { id, value } }) => {
    const [section, field] = id.split('.');
    setFormData((prev) => {
      return { ...prev, [section]: { ...prev[section], [field]: value } };
    });
  };

  const getChangedFields = (initialData, currentData) => {
    const changes = {};
    for (const section in initialData) {
      for (const field in initialData[section]) {
        const initialValue = initialData[section][field];
        const currentValue = currentData?.[section]?.[field];
        if (!initialValue || !currentValue) continue


        if (JSON.stringify(initialValue) !== JSON.stringify(currentValue)) {
          if (!changes[section]) changes[section] = {};
          changes[section][field] = currentValue;
        }
      }
    }
    return changes;
  };

  const reformatData = (data) => {
    const reformatted = {};

    const requiredFromSections = fieldsConfig.sections
      .flatMap((section) => section.fields)
      .filter((field) => field.required)
      .map((field) => field.id);

    const requiredFields = [
      ...(fieldsConfig.requiredFields || []),
      ...requiredFromSections,
    ];

    Object.entries(data).forEach(([category, fields]) => {
      Object.entries(fields).forEach(([field, fieldData]) => {
        let value;

        if (Array.isArray(fieldData)) {
          value = fieldData
            .map((entry) => entry?.value ?? entry)
            .filter((item) => item !== null && item !== undefined);
        } else {
          value = fieldData?.value !== undefined ? fieldData.value : fieldData;
        }

        if (
          (Array.isArray(value) && value.length > 0) ||
          (value !== null && value !== undefined) ||
          requiredFields.includes(`${category}.${field}`)
        ) {
          if (!reformatted[category]) reformatted[category] = {};
          reformatted[category][field] = value;
        }
      });
    });

    return reformatted;
  };

  const handleSubmit = async () => {
    setLoading(true);

    const requiredFromSections = fieldsConfig.sections
      .flatMap((section) => section.fields)
      .filter((field) => field.required)
      .map((field) => field.id);

    const reformatedData = reformatData(formData);

    const missingFields = requiredFromSections.filter((field) => {
      const [section, key] = field.split('.');
      return !reformatedData[section]?.[key];
    });

    if (missingFields.length) {
      alert('Please fill in all required fields.');
      setLoading(false);
      return;
    }


      let readyData = reformatedData;
      console.log(readyData)
      if (
        (mode === 'edit' || mode === 'editWithName') &&
        changes == 'changedFields'
      ) {
        const changedFields = getChangedFields(initialFormData, readyData);
        if (Object.keys(changedFields).length === 0) {
          alert('No changes detected.');
          setLoading(false);
          return;
        }
        readyData = changedFields;
      }

      const updatedData = { id: data?.id || null, data: readyData };
      console.log(updatedData);

      await callAPI({
        request: submitAPI,
        method: 'post',
        params: updatedData,
        onSuccess: () => {
          onSubmitSuccess(updatedData, mode);
          onClose();
          setLoading(false);
        },
        onError: (errorMessage) => {
          console.error('Error submitting data:', errorMessage);
          setLoading(false);
        },
      });

  };

  const confirmDelete = async () => {
    setDeleteDialogOpen(true);
  };

  const handleDelete = async () => {
    // if (!window.confirm('Are you sure you want to delete?')) return;
    setDeleteDialogOpen(false);
    try {
      await callAPI({
        request: deleteAPI,
        method: 'delete',
        onSuccess: () => {
          onSubmitSuccess({ id: data.id }, 'delete');
          onClose();
        },
        onError: (error) => {
          console.error('Error deleting:', error);
        },
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const generateFormFields = (sectionFields) => {
    return sectionFields.map((fieldConfig) => {
      const [section, field] = (fieldConfig.id || '').split('.');
      const currentValue = formData?.[section]?.[field] || '';

      return (
        <FormField
          key={fieldConfig.id}
          onChange={
            fieldConfig.type !== 'multi-select'
              ? handleChange
              : handleMultiSelectChange
          }
          {...fieldConfig}
          value={currentValue}
        />
      );
    });
  };

  if (type === 'sidePeak')
    return (
      <>
        <Drawer
          anchor="right"
          open={true}
          onClose={onClose}
          sx={{
            '& .MuiDrawer-paper': {
              width: '40%',
              display: 'flex',
              flexDirection: 'column',
              height: '100vh',
            },
          }}
        >
          <Box
            sx={{
              padding: '0.5rem',
              position: 'sticky',
              top: 0,
              borderBottom: '1px solid #ccc',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            {(mode === 'edit' || mode === 'editWithName') && (
              <Tooltip title="Delete">
                <IconButton onClick={confirmDelete}>
                  <Delete20Regular />
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title="Close">
              <IconButton onClick={onClose}>
                <Dismiss20Regular />
              </IconButton>
            </Tooltip>
          </Box>

          <Box sx={{ flexGrow: 1, overflowY: 'auto', padding: '2rem' }}>
            <h1>{title}</h1>
            <br />
            {fieldsConfig.sections.map((section) => (
              <div key={section.section}>
                <Typography variant="h5" sx={{ fontWeight: '600', mb: 1 }}>
                  {section.section}
                </Typography>
                <Divider sx={{ bgcolor: 'var(--gray-300)', mb: 3 }} />
                <Stack spacing={2}>{generateFormFields(section.fields)}</Stack>
                <br />
              </div>
            ))}
          </Box>
          <Box
            sx={{
              position: 'sticky',
              bottom: 0,
              backgroundColor: 'white',
              padding: '1rem',
              borderTop: '1px solid #ccc',
              display: 'flex',
              gap: '1rem',
              justifyContent: 'flex-end',
            }}
          >
            {' '}
            <Button
              variant="contained"
              textColor="var(--black)"
              bgColor="#F3F4F6"
              size="small"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button variant="contained" size="small" onClick={handleSubmit}>
              {mode === 'edit' || mode === 'editWithName'
                ? 'Save Changes'
                : 'Create'}
            </Button>
          </Box>
        </Drawer>
        <Dialog
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
          title="Are you sure you want to delete this item?"
          description="All information about this item will be lost. This action cannot be undone."
          confirmText="Delete"
          cancelText="Cancel"
          onConfirm={handleDelete}
          onCancel={() => setDeleteDialogOpen(false)}
          confirmColor='#DC2626'
        />
      </>
    );

  return (
    <MuiDialog
      open={true}
      onClose={onClose}
      width="sm"
      fullWidth
      sx={{ '& .MuiDialog-paper': { padding: '2rem' } }}
    >
      <h1>{title}</h1>
      <hr />
      {fieldsConfig.sections.map((section) => (
        <div key={section.section}>
          <Typography variant="h5" sx={{ fontWeight: '600', mb: 0.5 }}>
            {section.section}
          </Typography>
          <Stack spacing={2}>{generateFormFields(section.fields)}</Stack>
          <br />
        </div>
      ))}
      <div className="sidepeek-footer">
        <Stack direction="row" justifyContent="flex-end" gap={1}>
          <Button
            variant="contained"
            textColor="var(--black)"
            bgColor="#F3F4F6"
            size="small"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button variant="contained" size="small" onClick={handleSubmit}>
            {mode === 'edit' || mode === 'editWithName'
              ? 'Save Changes'
              : 'Create'}
          </Button>
          {(mode === 'edit' || mode === 'editWithName') && (
            <button onClick={confirmDelete}>Delete</button>
          )}
        </Stack>
      </div>
    </MuiDialog>
  );
};

export default FormModal;
